import { MailWarningIcon } from 'lucide-react';
import React, { useState } from 'react';

const FaqToggle = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: 'Do I really pay zero commission in the first year?',
      answer:
        "Yes! You keep 100% of your earnings for your first 12 months with no commission deducted from orders or bills.",
    },
    {
      question: 'What devices do I need?',
      answer: 'You only need a smartphone, tablet, or laptop. No extra hardware is required.',
    },
    {
      question: "How do I get more visibility?",
      answer: "Your visibility increases through customer reviews, local discovery features, and in-app marketing campaigns. The better your performance, the more discoverable you become.",
    },
    {
      question: 'What happens after the first year?',
      answer: 'After the first year, you can continue using Maamaas on a subscription plan with a nominal platform fee, giving you uninterrupted access to all tools.',
    },
    {
      question: "Can my team manage orders and bookings?",
      answer: 'Yes, multi-user access lets your team manage operations securely while you retain full control over your business.',
    },

  ];

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div style={styles.container}>
      <h2 className='faqsmamaas' style={{ textAlign: 'center', fontSize: '50px', fontWeight: 'bold', }}>
        <span style={{ color: 'gold' }}>VENDOR </span>
        <span style={{ color: 'white' }}>FAQs</span>
        <span style={{ color: 'gold' }}> – Know Before You Tap</span>
      </h2>
      {faqData.map((item, index) => (
        <div key={index} style={styles.card}>
          <div style={styles.questionRow} onClick={() => toggleFAQ(index)}>
            <p style={styles.question}>{item.question}</p>
            <span style={styles.icon}>{activeIndex === index ? '▲' : '▼'}</span>
          </div>
          {activeIndex === index && (
            <div style={styles.answer}>
              <p>{item.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

// Inline CSS (internal styling)
const styles = {
  container: {
    // maxWidth: '1357px',
    margin: 'auto',
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#2a0947',
    marginTop: '30px'
  },
  title: {
    textAlign: 'center',
    marginBottom: '20px',
    fontSize: '50px',
    fontWeight: 'bold',

  },
  card: {
    backgroundColor: '#f3f6fb',
    marginBottom: '10px',
    borderRadius: '8px',
    padding: '10px 15px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
  },
  questionRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
  },
  question: {
    fontWeight: 'bold',
    fontSize: '16px',
    margin: '0',
  },
  icon: {
    fontSize: '20px',
    color: '#555',
  },
  answer: {
    marginTop: '10px',
    fontSize: '15px',
    color: '#444',
  },
};

export default FaqToggle;
